// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:767px){.contact-form.form{margin-bottom:20px}}.contact-form.form .form__row .contact-form__phone-field .input-group__error{width:205%}@media (max-width:767px){.contact-form.form .form__row .contact-form__phone-field .input-group__error{width:100%}}", ""]);
// Exports
module.exports = exports;
